/* Add-to-cart behaviour for the delivery upgrades block (<delivery-upgrade-add>).
   Adds the variant from data-variant-id via the AJAX cart and refreshes the
   cart drawer (falls back to the cart page when no drawer is present). */
(function () {
  if (window.customElements && customElements.get('delivery-upgrade-add')) return;

  class DeliveryUpgradeAdd extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.labelEl = this.button.querySelector('.btn-label');
      this.defaultLabel = this.labelEl ? this.labelEl.textContent : '';
      this._onClick = this.addToCart.bind(this);
      this.button.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this._onClick);
    }

    setLabel(text) {
      if (this.labelEl) this.labelEl.textContent = text;
    }

    addToCart() {
      const variantId = Number(this.dataset.variantId);
      if (!variantId || this.button.classList.contains('delivery-upgrade-card__btn--added')) return;

      const cart = document.querySelector('cart-drawer');
      const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

      const payload = { items: [{ id: variantId, quantity: 1 }] };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender().map((s) => s.id);
        payload.sections_url = window.location.pathname;
        cart.setActiveElement(document.activeElement);
      }

      this.button.classList.add('delivery-upgrade-card__btn--loading');
      this.button.disabled = true;

      fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((response) => {
          this.button.classList.remove('delivery-upgrade-card__btn--loading');

          if (response.status) {
            // Cart error (e.g. sold out) – allow retrying.
            this.button.disabled = false;
            this.setLabel('Try again');
            return;
          }

          this.button.classList.add('delivery-upgrade-card__btn--added');
          this.setLabel('Added');

          if (cart && response.sections) {
            cart.renderContents(response);
          } else if (cart && typeof cart.open === 'function') {
            cart.open();
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(() => {
          this.button.classList.remove('delivery-upgrade-card__btn--loading');
          this.button.disabled = false;
          this.setLabel(this.defaultLabel || 'Add');
        });
    }
  }

  customElements.define('delivery-upgrade-add', DeliveryUpgradeAdd);
})();
